// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"27518c75","617":"1e48bc30"}[chunkId] + ".chunk.css";
};